<template>
    <div>
    <div v-show="selected != null">
        <input type="text" hidden v-model="hermano_id" id="buscarFamiliarInputId">
        <div class="card mb-2" v-for="hermano in selected.hermanos" :key="hermano.id+'h'">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <h5 class="m-0">{{hermano.fullName}}</h5>
                    <span v-if="hermano.registro_academico.programa">
                        {{hermano.registro_academico.programa.nombre}}
                    </span>
                </div>
                <div class="d-flex justify-content-between">
                    <span v-if="hermano.registro_academico.institucion">
                        {{hermano.registro_academico.institucion.nombre}}
                    </span>
                    <h5><span class="badge badge-info">HERMANO</span></h5>
                </div>
            </div>
        </div>
        <div class="card mb-2" v-for="familiar in selected.familiares" :key="familiar.id+'f'">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <h5 class="m-0">{{familiar.fullName}}</h5>
                    <h5><span class="badge badge-success" v-text="familiar.parentesco.toUpperCase()"></span></h5>
                </div>
                <span>{{familiar.correo}}</span>
            </div>
        </div>
        <div class="text-right">
            <button class="btn btn-light btn-sm"
                @click="cancelar">
                Cancelar vinculación
            </button>
        </div>
    </div>
    <div v-show="!selected" class="component-searchbar w-100">
        <input type="text"
            class="form-control w-100"
            :placeholder="placeholder ? placeholder : 'Buscar...'"
            v-model="text"
            :id="computed_id">
        <div class="list" :hidden="hidden" style="max-height: 200px;">
            <p class="message m-0">{{message}}</p>
            <div v-for="alumno in data" class="item" :key="alumno.id"
                @click="select(alumno.id)">
                <div>
                    <p v-text="alumno.fullName" class="m-0"></p>
                    <span v-if="alumno.registro_academico.institucion" 
                        v-text="alumno.registro_academico.institucion.nombre">
                    </span>
                </div>
                <span v-if="alumno.registro_academico.programa" 
                    v-text="alumno.registro_academico.programa.nombre">
                </span>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'id',
        'placeholder',
        'route',
    ],
    data() {return {
        hidden: true,
        text: '',
        data: [],
        selected: {
            hermanos: [],
            familiares: [],
        },
        message: 'Al menos 4 letras...',
        hermano_id: null,
    }},
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('nsearch-' + this._uid);
            } else {
                return this.id;
            }
        },
    },
    mounted() {
        const vm = this;
        const searchInput = $('#'+vm.computed_id);

        searchInput.focus(function() {
            vm.hidden = false;
        });
        searchInput.focusout(function() {
            setTimeout(function() {
                if(!searchInput.is(':focus')) {
                    vm.hidden = true;
                }
            }, 200);   
        });

        let timeout = null;
        searchInput.on('input', function() {
            console.log('encuentro');
            if(vm.text.length < 4) {
                vm.message = 'Al menos 4 letras...'
                vm.data = [];
            } else {
                vm.message = 'Buscando...';
            }

            if (timeout !== null) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function() {
                if(vm.text != '' && vm.text.length > 3) {
                    vm.search();
                }
            }, 1000); 
        });
    },
    methods: {
        search() {
            Axios.get('/prospectos/findBrother', {params: {text: this.text}}).then(res => {
                this.data = res.data;
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error al buscar otros alumnos');
                }
            });
        },
        select(id) {
            this.hermano_id = id;
            Axios.get('/prospectos/findFamily', {params: {id: id}}).then(res => {
                this.selected = res.data;
                this.text = '';
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error al buscar la relación familiar');
                }
            });
        },
        cancelar() {
            this.selected = {
                hermanos: [],
                familiares: [],
            };
            this.hermano_id = null;
        },
    },
}
</script>